import React, { useContext, useState, useEffect } from 'react'
import { getFunctions, httpsCallable } from "firebase/functions";

import { AuthContext } from '@/contexts/AuthContext'
import { convertAmount } from '@/utils/currencyResolver'

export default function AccountGeneral() {
  const { ordersData } = useContext(AuthContext)
  return (
    <div className="grid gap-6">
      {ordersData.filter(item => ["Withdraw", "Deposit"].includes(item.type)).length > 0 ? <AccountForm /> : (
        <p className="py-16 text-center text-gray-300">You have no cashier transactions in your history.</p>
      )}
    </div>
  )
}

const AccountForm = () => {
  const { ordersData } = useContext(AuthContext)

  return (
    <table className="w-full text-gray-300">
      <thead className="mb-4">
        <tr>
          <th className="w-32 p-4 pt-0 text-sm font-medium text-left">Date</th>
          <th className="w-24 p-4 pt-0 text-sm font-medium text-center">Amount</th>
          <th className="w-24 p-4 pt-0 text-sm font-medium text-center">Type</th>
          <th className="w-24 p-4 pt-0 text-sm font-medium text-right">Status</th>
        </tr>
      </thead>
      <tbody>
        {ordersData
          .filter(item => ["Withdraw", "Deposit"].includes(item.type))
          .sort((a, b) => a.createdAt > b.createdAt ? -1 : 1)
          .map((item, index) => (
            <tr className="p-4 odd:bg-gray-800">
              <td className="p-4 text-sm rounded-l">{new Date(item.createdAt.seconds * 1000).toLocaleDateString()} {new Date(item.createdAt.seconds * 1000).toLocaleTimeString()}</td>
              <td className="p-4 text-sm text-center">{convertAmount(item.amount)}</td>
              <td className="p-4 text-sm text-center">{item.type}</td>
              <td className="p-4 text-sm rounded-r text-right">{item.status}</td>
            </tr>
          )
          )}
      </tbody>
    </table>
  )
}